import * as z from 'zod'

// generic schemas for shared types

export const moneyZ = z.object({
  amount: z.number(),
  amountMinor: z.number(),
  currency: z.string(),
})

export const partyZ = z.object({
  adults: z.number(),
  childAges: z.number().array(),
  dogs: z.number().optional(),
})

// key is the extra id, and value is the quantity
export const selectedExtrasZ = z.record(z.number())
export type SelectedExtras = z.infer<typeof selectedExtrasZ>

export const extraZ = z.object({
  description: z.string(),
  descriptionNeedsTranslation: z.boolean(),
  id: z.string(),
  isCompulsory: z.boolean(),
  max: z.number(),
  name: z.string(),
  price: moneyZ,
  pricingDisplay: z.string(),
  pitchtypeExtra: z
    .object({
      included: z.number().nullable(),
      maximum: z.number().nullable(),
    })
    .optional()
    .nullable(),
  terms: z.string().array().nullable().optional(),
})
export type Extra = z.infer<typeof extraZ>

export const pricedTaxZ = z.object({
  amount: moneyZ,
  isCommissionable: z.boolean(),
  isHidden: z.boolean(),
  isInclusive: z.boolean(),
  name: z.string(),
  rate: z.number(),
  type: z.string(),
})
export type PricedTax = z.infer<typeof pricedTaxZ>

export const taskStatusZ = z.object({
  successful: z.boolean(),
  failed: z.boolean(),
  ready: z.boolean(),
  taskStatus: z.string(),
  id: z.string(),
})
